import { Provider } from "react-redux";
import { HashRouter, Outlet, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import "./styles/general.css";
import "./styles/main.css";

import { store } from "./store";
import { LoaderProvider } from "./context/Preloader";
import { ThemeProvider } from "./context/Themes";
import { Error } from "./pages/supports";
import { PermissionsGuard } from "./components/guards";
// Per-module route trees
import { accountRoutes } from "./pages/account/account.routes";
import { adminRoutes } from "./pages/admin/admin.routes";
import { administrationRoutes } from "./pages/administration/administration.routes";
import { authRoutes } from "./pages/auth/auth.routes";
import { clientRoutes } from "./pages/client/client.routes";
import { crmRoutes } from "./pages/crm/crm.routes";
import { crmProRoutes } from "./pages/crm-pro/crm-pro.routes";
import { dashboardRoutes } from "./pages/dashboard/dashboard.routes";
import { employeeRoutes } from "./pages/employee/employee.routes";
import { expenseRoutes } from "./pages/expense/expense.routes";
import { invoicesRoutes } from "./pages/invoices/invoices.routes";
import { libraryRoutes } from "./pages/library/library.routes";
import { masterRoutes } from "./pages/master/master.routes";
import { myProfileRoutes } from "./pages/my-profile/my-profile.routes";
import { officeRoutes } from "./pages/office/office.routes";
import { performanceGuaranteesRoutes } from "./pages/performanceGuarantees/performanceGuarantees.routes";
import { projectRoutes } from "./pages/project/project.routes";
import { purchaseOrdersRoutes } from "./pages/purchaseOrders/purchaseOrders.routes";
import { reportRoutes } from "./pages/report/report.routes";
import { stockRoutes } from "./pages/stock/stock.routes";
import { subcontractorsRoutes } from "./pages/subcontractors/subcontractors.routes";
import { superadminRoutes } from "./pages/superadmin/superadmin.routes";
import { taskRoutes } from "./pages/task/task.routes";
import { toolsRoutes } from "./pages/tools/tools.routes";
import { transactionRoutes } from "./pages/transaction/transaction.routes";
import { vendorRoutes } from "./pages/vendor/vendor.routes";
import { workerRoutes } from "./pages/worker/worker.routes";

export function App() {
  return (
    <Provider store={store}>
      <ToastContainer />
      <ThemeProvider>
        <LoaderProvider>
          <HashRouter>
            <Routes>
              {authRoutes}

              <Route
                element={
                  <PermissionsGuard>
                    <Outlet />
                  </PermissionsGuard>
                }
              >
                {dashboardRoutes}
                {myProfileRoutes}
                {masterRoutes}

                {/* Admin Pages */}
                {employeeRoutes}

                {/* Super Admin - Companies */}
                {superadminRoutes}

                {/* Projects */}
                {projectRoutes}

                {/* Office Account */}
                {officeRoutes}

                {/* Expenses */}
                {expenseRoutes}

                {/* Libraries */}
                {libraryRoutes}

                {/* Sub Contractors */}
                {subcontractorsRoutes}

                {/* CRM */}
                {crmRoutes}

                {/* CRM Pro */}
                {crmProRoutes}

                {/* Workers */}
                {workerRoutes}

                {/* Administration */}
                {administrationRoutes}

                {/* Customer / Client */}
                {clientRoutes}

                {/* Vendor */}
                {vendorRoutes}

                {/* Purchase Order */}
                {purchaseOrdersRoutes}

                {/* Tools */}
                {toolsRoutes}

                {/* Accounts */}
                {accountRoutes}

                {/* Invoices */}
                {invoicesRoutes}

                {/* Transactions */}
                {transactionRoutes}

                {/* Performance Guarantee */}
                {performanceGuaranteesRoutes}

                {/* Reports */}
                {reportRoutes}

                {/* Stock and Yards */}
                {stockRoutes}

                {/* Task */}
                {taskRoutes}

                {/* Notifications, Plans, Print */}
                {adminRoutes}
              </Route>

              <Route path="*" element={<Error />} />
            </Routes>
          </HashRouter>
        </LoaderProvider>
      </ThemeProvider>
    </Provider>
  );
}
